const state = {
    tags:[],
};

const getters = {
    tags: state => state.tags,
};

const actions = {
    getTags({commit, state}){
        axios.get('/api/admin/tag').then((response) => {
            commit('setTags', response.data.data);
        })
    }
};

const mutations = {
    setTags(state, tags){
        state.tags = tags;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
